export default [
  {
    name: 'project_event_dates',
    component_path: 'modules/templates/blocks/project/ProjectEventDates'
  }
]